import Model from './Model'

export default class Template extends Model {
  id: number
  title: string
  description: string
  dropoff: boolean
  fullDropoff: boolean
  autoRestart: boolean
  icon: {
    name: string
    width: string
    height: string
  }
  type: string

  constructor(json, locale) {
    super({})
    this.id = json.id
    this.title = this.translateField(json._title, locale)
    this.description = this.translateField(json._description, locale)
    this.dropoff = json.dropoff
    this.fullDropoff = json.full_dropoff
    this.autoRestart = json.auto_restart
    this.icon = this.setTemplateIcon(json)
    this.type = !json.dropoff ? 'simple' : json.full_dropoff ? 'full_dropoff' : 'dropoff'
  }

  setTemplateIcon(report) {
    const name = !report.dropoff ? 'report-simple' :
                      report.full_dropoff ? 'report-double' : 'report-double-dash'
    const width = !report.dropoff ? '10' : report.full_dropoff ? '14' : '14'
    const height = !report.dropoff ? '14' : report.full_dropoff ? '18' : '17'
    return { name, width, height }
  }
}
